<template>
  <div class="liquor-background">
    <div class="map" v-if="map">
      <WorldMap />
    </div>

    <div class="slides">
      <div
        class="slide"
        v-for="(item, index) in list"
        :key="index"
        :class="{
        'prev': index === prevIndex,
        'curr': index === currIndex,
        'next': index === nextIndex
    }"
      >
        <div :style="`background-image: url(${list[index]})`"></div>
      </div>
    </div>
  </div>
</template>

<script>
import WorldMap from "@/components/liquor/WorldMap";
export default {
  name: "Background",
  props: {
    map: {
      type: Boolean,
      default: true
    }
  },
  components: {
    WorldMap
  },
  data() {
    return {
      list: [
        "/liquor/轮播背景图1.jpg",
        "/liquor/轮播背景图2.jpg",
        "/liquor/轮播背景图3.jpg",
        "/liquor/轮播背景图4.jpg"
      ],
      currIndex: 0
    };
  },
  computed: {
    prevIndex: function() {
      if (this.currIndex === 0) {
        return this.list.length - 1;
      } else {
        return this.currIndex - 1;
      }
    },
    nextIndex: function() {
      if (this.currIndex === this.list.length - 1) {
        return 0;
      } else {
        return this.currIndex + 1;
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      setInterval(() => {
        if (this.currIndex == this.list.length - 1) {
          this.currIndex = 0;
        } else {
          this.currIndex += 1;
        }
      }, 9000);
    }
  }
};
</script>

<style lang="scss">
.liquor-background {
  //   overflow: hidden;

  z-index: -999;

  width: 100%;
  height: 100vh;
  //   overflow: hidden;
  //   position: relative;

  top: 0;
  left: 0;
  //   opacity: 0.4;

  .map {
    z-index: 998;
    width: 100%;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    top: 0;
    left: 0;
  }

  .slides {
    z-index: 997;
    position: absolute;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    top: 0;
    left: 0;
  }

  .slide {
    z-index: -1000;
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;

    transition: all 4000ms ease 0s;
    opacity: 0;
    div {
      width: 100%;
      height: 100vh;
      background-position: center top;
      background-size: cover;
    }
  }

  .prev {
    opacity: 0;
    transform: scale(2) rotate(-35deg);
  }

  .curr {
    opacity: 1;
    transform: scale(1) rotate(0);
  }

  .next {
    opacity: 0;
    transform: scale(2) rotate(35deg);
  }
}
</style>